import { LoadingButton } from "@mui/lab";
import {
  Button,
  Checkbox,
  Chip,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useExportacionesContext } from "../exportaciones-context";
import {
  ExportacionProvider,
  useExportacionContext,
} from "./exportacion-context";
import { MdArrowBack } from "react-icons/md";

export function ExportacionForm() {
  return (
    <ExportacionProvider>
      <Form />
    </ExportacionProvider>
  );
}

function Form() {
  const params = useParams();
  const navigate = useNavigate();

  const { addExportacion, isAdding, updateExportacion, isUpdating, cancel } =
    useExportacionesContext();

  const { exportacion, setExportacion, isEditing } = useExportacionContext();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditing) {
        return await updateExportacion({
          exportacionId: params.exportacion_id,
          exportacion,
        });
      } else {
        return await addExportacion({ exportacion });
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  return (
    <Container maxWidth="sm" className="animate__animated animate__fadeIn">
      <Paper
        component="form"
        onSubmit={handleSubmit}
        onReset={cancel}
        sx={{ padding: 2 }}
        variant="outlined"
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <Tooltip title="Atrás">
                  <IconButton
                    onClick={() => navigate("../..", { replace: true })}
                  >
                    <MdArrowBack />
                  </IconButton>
                </Tooltip>

                <Typography variant="h6">
                  {`${!!isEditing ? "Editar" : "Agregar"} exportación`}
                </Typography>
              </Stack>

              {!!isEditing && (
                <Chip
                  label={
                    !!exportacion.exportacion_verificada
                      ? "Verificado"
                      : "Pendiente"
                  }
                  color={
                    !!exportacion.exportacion_verificada ? "success" : "warning"
                  }
                  size="small"
                  variant="outlined"
                />
              )}
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="text"
              label="Detalles"
              value={exportacion.exportacion_detalles}
              onChange={(e) =>
                setExportacion((exportacion) => ({
                  ...exportacion,
                  exportacion_detalles: e.target.value,
                }))
              }
              size="small"
              fullWidth
              required
              disabled={!!exportacion.exportacion_verificada}
            />
          </Grid>

          <Grid item xs={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={exportacion.exportacion_principal}
                    onChange={(e) =>
                      setExportacion((exportacion) => ({
                        ...exportacion,
                        exportacion_principal: e.target.checked,
                      }))
                    }
                  />
                }
                label="¿Es una exportación principal?"
                disabled={!!exportacion.exportacion_verificada}
              />
            </FormGroup>
          </Grid>

          <Grid item xs={12}>
            {!exportacion.exportacion_verificada && (
              <Stack direction="row" justifyContent="end" spacing={1}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  size="small"
                  color={!!isEditing ? "warning" : "success"}
                  loading={!!isUpdating || !!isAdding}
                >
                  {!!isEditing ? "Actualizar" : "Agregar"}
                </LoadingButton>

                <Button
                  type="reset"
                  size="small"
                  variant="outlined"
                  color="inherit"
                  disabled={!!isUpdating || !!isAdding}
                >
                  Cancelar
                </Button>
              </Stack>
            )}
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
